import gql from 'graphql-tag'

import { AppCancelAppointementMutation } from '../../../types/api'

export default {
  mutation: gql`
    mutation AppCancelAppointement($appointment: ID!) {
      rdvCancelAppointment(appointment: $appointment) {
        id
        first_name
        last_name
      }
    }
  `,
  transformer: (response: AppCancelAppointementMutation) => {
    return response.rdvCancelAppointment
  },
}
